import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'bdo-tariff-prices-workingprice',
    templateUrl: './tariff-prices-workingprice.component.html',
    styleUrl: './tariff-prices-workingprice.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

export class TariffPricesWorkingpriceComponent {
  @Input() price: number = null;
  @Input() description: string = '';
  @Input() textInfoI: string = '';
}
